import { Grid, Typography } from "@mui/material";
import _ from "lodash";
import moment from "moment";
import formatGender from "../../../utils/formatGender";
import { useAuth } from "../../../auth/context";

const styleSubtittles = {
  fontWeight: 700,
  fontFamily: "Inter",
  color: "primary.main",
};

const styleTexts = {
  fontFamily: "Inter",
  color: "text.black",
  mt: 1,
};

const PatientData = ({ patient }) => {
  const { name, surname, documentNumber, gender, birthDate, email, phone, healthInsurance, healthInsurancePlan, insuranceNumber } = patient;
  const { user } = useAuth();
  const showShareInfo = user.showPatientShareInfo();

  return (
    <Grid container spacing={{ xs: 2, sm: 6 }}>
      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>Apellido/s</Typography>
        <Typography sx={styleTexts}>{surname || "-"}</Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>Nombre/s</Typography>
        <Typography sx={styleTexts}>{name || "-"}</Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>N° de Documento</Typography>
        <Typography sx={styleTexts}>{documentNumber || "-"}</Typography>
      </Grid>

      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>Fecha de Nacimiento </Typography>
        <Typography sx={styleTexts}>
          {birthDate ? moment(birthDate).format("DD/MM/YYYY") : "-"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>Género</Typography>
        <Typography sx={styleTexts}>
          {" "}
          {formatGender(gender) || "-"}
        </Typography>
      </Grid>

      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>Obra Social</Typography>
        <Typography sx={styleTexts}>
          {_.chain(healthInsurance).toLower().upperFirst().value() || "-"}
          {healthInsurancePlan ? ` (${healthInsurancePlan})` : ""}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography sx={styleSubtittles}>N° de Afiliado</Typography>
        <Typography sx={styleTexts}>{insuranceNumber || "-"}</Typography>
      </Grid>

      {showShareInfo && (
      <>
        <Grid item xs={6} sm={4}>
          <Typography sx={styleSubtittles}>Email</Typography>
          <Typography sx={styleTexts}> {email || "-"}</Typography>
        </Grid>

        <Grid item xs={6} sm={4}>
          <Typography sx={styleSubtittles}>Teléfono</Typography>
          <Typography sx={styleTexts}>{phone || "-"}</Typography>
        </Grid>
      </>
      )}
    </Grid>
  );
};

export default PatientData;
